<template>
    <div>
        <div :class="'triviaquizPage anim'+ ( open ? ' open' : '' )">
            <div class="container h-100 animate__animated animate__fadeIn">
                <div v-if="open" class="row h-100">
                    <div class="col-md-6 h-100 m-auto d-flex flex-fill flex-column relative">
                        <a @click.prevent="hide();btnSfx();" href="#" class="btnClose"></a>
                        <div class="content">
                            <div v-if="user != null" class="trivia-top-bar d-flex">
                                <a  @click.prevent="jokerInfoShow = !jokerInfoShow;btnSfx();" href="#" class="trivia-joker-info-btn">
                                    <i class="bee"></i>
                                    <span>{{ user.jokers.abbr() }}</span>
                                </a>
                                <div :class="'trivia-joker-info'+(jokerInfoShow ? ' open': '')">
                                    <div :class="jokerInfoShow ? 'animate__animated animate__fadeIn animate__delay-0_5s': 'animate__animated animate__fadeOut'">
                                        <h5 class="text-orange mb-1">{{ $t('trivia.joker_slide_info_title') }}</h5>
                                        <p>
                                            {{ $t('trivia.joker_slide_info_text') }}<br><br>
                                            <a href="https://adbalu.com/jokers" class="text-primary">{{ $t('trivia.joker_slide_info_link') }}</a>
                                        </p>
                                    </div>
                                    <b-button @click="$emit('changeTab','shop-tab');hide();btnSfx();" variant="orange" class="pl-4 pr-4"><b>KUPI</b></b-button>
                                </div>
                                <div class="flex-fill">
                                    <div v-if="quiz != null && quiz.domain != null" class="trivia-domain">
                                        <span>{{ $t('trivia.home_domain_title') }}</span>
                                        <h4 class="text-uppercase" :style="'color:#'+quiz.domain.color+';'">{{ quiz.domain.name }}</h4>
                                        <i></i>
                                    </div>
                                </div>
                                <a v-if="quiz != null" @click.prevent="jokerInfo();btnSfx();" href="#" class="trivia-info-btn"></a>
                            </div>

                            <div v-if="quiz != null && quiz.participantLimit !== undefined && quiz.participantLimit > 0" class="limit-info">
                                <div>{{ $t('home.home_quiz_participant_limit_title') }}</div>
                                <b :class="quiz.participantCount >= quiz.participantLimit ? 'text-danger' : ''">{{ quiz.participantCount }} / {{ quiz.participantLimit }}</b>
                            </div>

                            <div class="bear-video p-lg-3 animate__animated animate__slow animate__fadeIn">
                                <video v-if="quiz != null && quiz.rewardingType == 'TRANSFER'" :src="user.mtsCustomer ? '/video/mts/bear-super.mp4':'/video/default/bear-super.mp4'" type="video/mp4" muted autoplay loop playsinline>Your browser does not support the video.</video>
                                <video v-else-if="quiz != null && quiz.userParticipationStatus != undefined" :src="user.mtsCustomer ? '/video/mts/bear-quiz-apply.mp4':'/video/default/bear-quiz-apply.mp4'" type="video/mp4" muted autoplay loop playsinline>Your browser does not support the video.</video>
                                <video v-else :src="user.mtsCustomer ? '/video/mts/bear-quiz-wait.mp4':'/video/default/bear-quiz-wait.mp4'" type="video/mp4" muted autoplay loop playsinline>Your browser does not support the video.</video>
                            </div>

                            <div v-if="quiz != null" :class="'trivia-tab-bottom' + (quiz.rewardingType == 'TRANSFER' ? ' super' : '')">

                                <div v-if="quiz.userParticipationStatus != undefined && startDate == '00:00s'" class="start-holder pl-md-3 pr-md-3 pl-lg-5 pr-lg-5">
                                    <div class="d-flex">
                                        <h3 v-if="follow" class="text-success ml-auto mr-auto mt-3 mb-3">{{ $t('trivia.home_quiz_start_info_in') }}</h3>
                                        <h3 v-else class="text-success ml-auto mr-auto mt-3 mb-3">{{ $t('trivia.home_quiz_start_info') }}</h3>
                                    </div>
                                    <div class="award ml-md-3 mr-md-3">
                                        {{ $t('trivia.home_quiz_award') }}
                                        <span><img src="/images/diamond.png"/> {{ quiz.awardsBudget.toLocaleString('sr-RS') }}</span>
                                    </div>
                                </div>

                                <div v-else-if="quiz.userParticipationStatus == undefined && applyDate <= 0" class="apply-holder pl-md-3 pr-md-3 pl-lg-5 pr-lg-5">
                                    <div class="startDateTimer mb-2">
                                        <span v-if="quiz.rewardingType == 'TRANSFER'">{{ $t('trivia.home_quiz_super_wait_start_at') }}</span>
                                        <span v-else>{{ $t('trivia.home_quiz_wait_start_at') }}</span> 
                                        {{ startDate }}
                                    </div>
                                    
                                    <b-button v-if="!quiz.participantLimit || quiz.participantCount < quiz.participantLimit" @click="apply();btnSfx();" size="lg" class="btn-quiz-apply"> 
                                        <span v-if="quiz.stake > 0">{{ quiz.stake.abbr(true) }} <img src="/images/token.png"/></span> 
                                        {{ $t('trivia.home_quiz_apply_btn') }}
                                    </b-button>
                                    <h4 v-else class="text-danger p-3">{{ $t('home.home_quiz_participant_limit_reach') }}</h4>

                                    <div class="award ml-md-3 mr-md-3">
                                        {{ $t('trivia.home_quiz_award') }}
                                        <span><img src="/images/diamond.png"/> {{ quiz.awardsBudget.toLocaleString('sr-RS') }}</span>
                                    </div>
                                </div>

                                <div v-else class="wait-holder pl-md-3 pr-md-3 pl-lg-5 pr-lg-5">
                                    
                                    <div class="startDateTimer mb-2">
                                        {{ $t('trivia.home_quiz_wait_start_at') }}
                                        <span>{{ startDate }}</span>
                                    </div>

                                    <div v-if="quiz.userParticipationStatus == 'ENROLLED'">
                                        <p class="text-primary">{{ $t('trivia.home_quiz_applied_info') }}</p>
                                    </div>

                                    <div class="award ml-md-3 mr-md-3">
                                        {{ $t('trivia.home_quiz_award') }}
                                        <span><img src="/images/diamond.png"/> {{ quiz.awardsBudget.toLocaleString('sr-RS') }}</span>
                                    </div>

                                </div>

                            </div>
                            <div v-else class="trivia-tab-bottom">
                                <div class="m-auto">
                                    <h5 class="text-primary">{{ $t('trivia.home_quiz_no_quiz_info') }}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <trivia-quiz-info ref="infoPopup"></trivia-quiz-info>
    </div>
</template>

<script>
import Vue from 'vue'
import api from '../api'

import TriviaQuizInfo from './TriviaQuizInfo.vue';

const TriviaQuiz = Vue.component('trivia-quiz', {
    components: {
        TriviaQuizInfo
    },
    startDateTimer: null,
    applyDateTimer: null,
    data(){
    	return {
            open: false,
            jokerInfoShow: false,
            startDate: '00:00h',
            applyDate: 0,
    	};
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        quiz() {
            return this.$store.state.trivia.quiz;
        },
        follow() {
            return this.$store.state.trivia.follow;
        },
        networkTimeDiff(){
            return this.$store.state.config.networkTimeDiff;
        }
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            this.open = true;
            this.$store.dispatch('trivia/getQuiz');
            this.$emit("hideBottomNav", true);
            document.querySelectorAll(".user-resources .profile")[0].style.visibility = 'hidden';
        },

        hide() {
            this.open = false;
            this.clearTimers();
            this.$emit("hideBottomNav", false);
            document.querySelectorAll(".user-resources .profile")[0].style.visibility = 'visible';
        },  

        apply(){
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.triviaQuizApply(this.quiz.id)
                .then((data) => {
                    $this.$store.dispatch('trivia/getQuiz');
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        jokerInfo(){
            this.$refs.infoPopup.show();
        },

        formatTime(time){
            if(time < 0) time = 0; // fix negative 
            let t = moment.duration(moment.utc(time).diff(moment.utc() + this.networkTimeDiff));

            if(t.asDays() > 1)
                return t.days()+"d"+(t.hours() > 0 ? " "+ this.pad2(t.hours())+ "h" : "");
            else if(t.hours() > 0)
                return this.pad2(t.hours()) + ":" + this.pad2(t.minutes())+"h";
            else if(t.minutes() > 0)
                return this.pad2(t.minutes()) + ":" + this.pad2(t.seconds())+"m";

            return '00:'+this.pad2(t.seconds())+"s";
        },
        pad2(number) {
            if(number < 0) number = 0;
            return (number < 10 ? '0' : '') + number
        },

        clearTimers(){
            if(this.startDateTimer != null){
                clearInterval(this.startDateTimer);
                this.startDateTimer = null;
            }
            if(this.applyDateTimer != null){
                clearInterval(this.applyDateTimer);
                this.applyDateTimer = null;
            }
        }
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
        this.clearTimers();
    },

    watch:{
        quiz(){
            this.clearTimers();
            if(this.quiz != null){
                const $this = this;

                if(this.quiz.startDateTime != undefined){
                    this.startDate = $this.formatTime(this.quiz.startDateTime); 
                    this.startDateTimer = setInterval(() => { 
                        let nt = moment.utc() + $this.networkTimeDiff;
                        if(moment.utc(nt).isBefore($this.quiz.startDateTime))
                            $this.startDate = $this.formatTime($this.quiz.startDateTime);
                        else $this.startDate = "00:00s";
                    }, 1000);
                }

                if(this.quiz.applyStartDateTime != undefined){
                    let nt = moment.utc() + $this.networkTimeDiff;
                    this.applyDate = moment.utc($this.quiz.applyStartDateTime).diff(moment.utc(nt)); 
                    this.applyDateTimer = setInterval(() => { 
                        let nt = moment.utc() + $this.networkTimeDiff;
                        if(!moment.utc(nt).isBefore($this.quiz.applyStartDateTime))
                            $this.applyDate = moment.utc($this.quiz.applyStartDateTime).diff(moment.utc(nt));
                    }, 1000);
                }

                if (this.quiz.userParticipationStatus != undefined)
                    this.$store.dispatch('sound/bg','BG_QuizActive');
                else 
                    this.$store.dispatch('sound/bg','BG_QuizWait');
            }
            else this.$store.dispatch('sound/bg','BG_QuizWait');
        },
    }
});

export default TriviaQuiz
</script>
